export default {

    //reducer const
    SET_ALERT: 'SET_ALERT',
    ALERT_PROPS:'ALERT_PROPS',
    ALERT_ACTIVE:'ALERT_ACTIVE',


    //component const
    MANDATORY_FIELDS_ERR:'MANDATORY_FIELDS_ERR',
    FORM_SUBMIT_SUCCESS:'FORM_SUBMIT_SUCCESS',
    NO_PERMISSION:'NO_PERMISSION',
    INVALID_ID:'INVALID_ID',
    POPULATE_ERROR:'POPULATE_ERROR',
    WORKFLOW_SUBMIT_SUCCESS:'WORKFLOW_SUBMIT_SUCCESS',
    WORKFLOW_UPDATE_FAILED:'WORKFLOW_UPDATE_FAILED',
    SUBMIT_ERROR:'SUBMIT_ERROR',
    STORAGE_MANAGEMENT:'STORAGE_MANAGEMENT',
    STORAGE_MANAGEMENT_APPLY: 'STORAGE_MANAGEMENT_APPLY'
}



// WEBPACK FOOTER //
// ./constants/alert.js